// extracted by mini-css-extract-plugin
export default {"warningIcon":"WarningModal__warningIcon--oDU21","title":"WarningModal__title--msCBa","message":"WarningModal__message--spYai"};